import '../../Pages/Client/Cvtheque/CvTheque.scss';

//import { Close } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Button, Dialog, IconButton, Toolbar, } from '@mui/material';
import PropTypes from 'prop-types';
import React , {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';

import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import usePostRequest from '../../hooks/usePostRequest';
import useWindowSize from '../../hooks/useWindowSize';
import { extractValue } from '../../Utils/utils';
import { buttonStyles, buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
import { SelectComponent, Transition } from '../shared/ReusableSmallComponents';

function DialogLierCvs({ selectedExperts, openLier, setOpenLier }) {
    DialogLierCvs.propTypes = {
        selectedExperts: PropTypes.any,
        openLier: PropTypes.any,
        setOpenLier: PropTypes.func,
    };
    const axiosPrivate = useAxiosPrivate();
    const [aoId, setAoId] = useState('');
    const { i18n } = useTranslation();
    const [allAos, setAllAos] = useState([]);
    const Ids = extractValue(selectedExperts, 'id'); //was _id, but _id now holds {$oid: "638655b07f4589a611bf9167"} and I can't simply change it because it will be overridden by ...expert?.expertData
    const {postData} = usePostRequest();
    const {device}=useWindowSize();

    const getMyOpenAOs = async () => {
        try {
            const response1 = await axiosPrivate.get('/ao/getMyOpenAOs');
            setAllAos(response1.data?.myAOs);
        } catch (error) {
            console.log(error.response?.status, error.response?.data.error);
        }
    };
    const handleCloseLier = () => {
        setOpenLier(false);
        setAoId('');};
    const linkCv2AO = async () => {
        try {
            postData({
                url: '/cvTheque/linkCv2AO', payload: { aoId, expertIds: Ids }
            }            ).
                then(()=> {
                    handleCloseLier();
                }
                );
        } catch (error) {
            console.log(error.response?.status, error.response?.data.error);
        }
    };

    // get Initial Data
    useEffect(() => {
        console.log(openLier);
        if (openLier)
            getMyOpenAOs();
    }, [openLier]);
    console.log({ selectedExperts, Ids });
    return (
        <Dialog
            open={openLier}
            onClose={handleCloseLier}
            TransitionComponent={Transition}
            fullScreen
            scroll={'paper'}
            PaperProps={{
                style: {
                    background: 'white',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <AppBar>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleCloseLier}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <div style={{display:'flex',flexDirection:'row',justifyContent:'center',paddingTop: '170px',minHeight:'900px'}}>
                <div
                    className='frame14CvTheque'
                >
                    <h4
                        className='titlesociete'
                    // style={{width:'594px'}}
                    >{i18n.t('Lier les CV selectionnés à un appel d\'offre')}</h4>
                    <div
                        className='frame16CvTheque'
                    >
                        <p className='frame19CvTheque'>{i18n.t('Rechercher un AO')}</p>
                        <div
                            className='frame20CvTheque'
                        >
                            <SelectComponent
                                label={i18n.t('Emplacement')}
                                val={aoId}
                                setVal={(e) => setAoId(e.target.value)}
                                listVal={allAos.map((ao) => {
                                    return {
                                        value: ao._id,
                                        label: ao?.intitulePoste + ' ' + ao?.aoId
                                    };
                                })}
                            />

                            {/*<Select
                                //labelId='demo-simple-select-label'
                                //id='demo-simple-select'
                                //value='Actif'
                                //label='Statut'
                                style={{backgroundColor:'white'}}
                                sx={{
                                    width: '391px',
                                }}
                                value={aoId}
                                onChange={(e)=> setAoId(e.target.value)}
                            >
                                {allAos.map((ao) => (
                                    <MenuItem
                                        key={ao._id}
                                        value={ao._id}
                                    >{ao?.intitulePoste + ' ' + ao?.aoId}
                                    </MenuItem>
                                ))}
                            </Select>*/}
                        </div>
                    </div>
                    <div
                        className='frame22CvTheque'
                    >
                        <div
                            className='frame23CvTheque'
                        >
                            <Button
                                variant='text'
                                style={{ ...buttonStyles(),...{width:device=='desktop' ? 'auto' :'100%'}}}
                                onClick={handleCloseLier}
                            >{i18n.t('Annuler')}</Button>
                            <Button
                                variant='contained'
                                //, ...{ width: '111px', }
                                style={{ ...buttonStylesGreen(false),...{width:device=='desktop' ? 'auto' :'100%'}}}
                                onClick={() => { linkCv2AO(); }}
                            >{i18n.t('Lier')}</Button>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>

    );
}

export default DialogLierCvs;
